import { useWorkAreaMaps } from 'modules/space_control/hooks/useWorkAreaMaps'

interface UseWorkAreaMapAvailabilityProps {
  workAreaId: number
}

export const useWorkAreaMapAvailability = ({ workAreaId }: UseWorkAreaMapAvailabilityProps) => {
  const { workAreaMapsById, loading } = useWorkAreaMaps({
    workAreaIds: [workAreaId],
  })

  const workAreaMap = workAreaMapsById[workAreaId]

  return {
    loading,
    workAreaMap,
  }
}
